module.exports = __webpack_public_path__ + "img/jjconbg.49909f32.png";